import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import { runAll, addOrRemove } from '@elliemae/ds-utilities/utils';
import useDerivedStateFromProps from '@elliemae/ds-utilities/hooks/useDerivedStateFromProps';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function useCheckableGroup(_ref) {
  var children = _ref.children,
      activeProp = _ref.active,
      multi = _ref.multi,
      _ref$onCheck = _ref.onCheck,
      onCheck = _ref$onCheck === void 0 ? function () {
    return null;
  } : _ref$onCheck;

  var _useDerivedStateFromP = useDerivedStateFromProps(activeProp),
      _useDerivedStateFromP2 = _slicedToArray(_useDerivedStateFromP, 2),
      active = _useDerivedStateFromP2[0],
      setActive = _useDerivedStateFromP2[1];

  var handleCheck = function handleCheck(_ref2, item) {
    var value = _ref2.target.value;
    setActive(function (prevActive) {
      var nextActive = multi ? addOrRemove(prevActive, value) : value;
      onCheck(nextActive, item);
      return nextActive;
    });
  };

  return React.Children.map(children, function (child) {
    var props = child.props;
    var checked = Array.isArray(active) ? active.indexOf(props.name) !== -1 : active === props.name;
    return /*#__PURE__*/cloneElement(child, _objectSpread(_objectSpread({}, props), {}, {
      checked: checked,
      onClick: runAll(handleCheck, props.onClick)
    }));
  });
}

function CheckableGroup(_ref3) {
  var _ref3$active = _ref3.active,
      active = _ref3$active === void 0 ? [] : _ref3$active,
      _ref3$multi = _ref3.multi,
      multi = _ref3$multi === void 0 ? false : _ref3$multi,
      children = _ref3.children;
  return useCheckableGroup({
    active: active,
    multi: multi,
    children: children
  });
}

CheckableGroup.propTypes = {
  /* The item (if multi false) or items (if multi true) selected */
  active: PropTypes.arrayOf(PropTypes.string),

  /* Whether is multi select or not */
  multi: PropTypes.bool,

  /* Handler when a user checks an item */
  onCheck: PropTypes.func
};

export default CheckableGroup;
export { useCheckableGroup };
//# sourceMappingURL=CheckableGroup.js.map
